import { createSlice } from "@reduxjs/toolkit";

const whatsappContacts = createSlice({
  name: "contacts",
  initialState: {
    usersById: {},
    userIds: [],
  },
  reducers: {
    setContactedUsers(state, action) {
      const users = action.payload;
      state.userIds = users.map((u) => u.id);
      users.forEach((u) => {
        state.usersById[u.id] = u;
      });
    },

    addContactedUsers(state, action) {
      action.payload.forEach((u) => {
        if (!state.userIds.includes(u.id)) {
          state.userIds.push(u.id);
        }
        state.usersById[u.id] = u;
      });
    },

    updateLatestMessage(state, action) {
      const { contactId, latestMessage } = action.payload;
      if (state.usersById[contactId]) {
        state.usersById[contactId].latest_message = latestMessage;
      }
    },

    updateLatestMessageStatus(state, action) {
      const { contactId, status } = action.payload;
      const user = state.usersById[contactId];
      if (user && user.latest_message) {
        user.latest_message.status = status;
      }
    },

    incrementUnread(state, action) {
      const id = action.payload;
      const user = state.usersById[id];
      if (user) {
        user.unread_messages_count = (user.unread_messages_count || 0) + 1;
      }
    },

    clearUnread(state, action) {
      const id = action.payload;
      if (state.usersById[id]) {
        state.usersById[id].unread_messages_count = 0;
      }
    },
  },
});

export const {
  setContactedUsers,
  addContactedUsers,
  updateLatestMessage,
  updateLatestMessageStatus,
  incrementUnread,
  clearUnread,
} = whatsappContacts.actions;
export default whatsappContacts.reducer;
